import { ThemeProps } from "@rjsf/core";

import Templates from "../Templates";
import Widgets from "../Widgets";

const Theme: ThemeProps = {
  templates: Templates,
  widgets: Widgets,
};

export default Theme;
